import { InstanceFactory } from "@amzn/ask-legal-domain";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useInstanceState } from "../components/instance/instance-store";

/**
 * Extract instanceId from route parameters
 * @param params Route parameters that may contain instanceId or other entity IDs
 * @returns The extracted instanceId or null if not found/valid
 */
export const extractInstanceFromParams = (
  params: {
    instanceId?: string,
    pageId?: string,
    pageLibraryId?: string,
    containerId?: string
  }
): string | null => {
  try {
    if (params.instanceId) {
      return params.instanceId;
    }
    if (params.pageId) {
      return InstanceFactory.fromEntityId(params.pageId);
    }
    if (params.pageLibraryId) {
      return InstanceFactory.fromEntityId(params.pageLibraryId);
    }
    if (params.containerId) {
      return InstanceFactory.fromEntityId(params.containerId);
    }
    return null;
  } catch (e) {
    console.warn("Error extracting instanceId from params:", e);
    return null;
  }
};

const useRoutedParamsWithContext = () => {
  const params = useParams();
  const { setInstanceId } = useInstanceState();

  useEffect(() => {
    const extractedInstanceId = extractInstanceFromParams(params);
    if (extractedInstanceId) {
      setInstanceId(extractedInstanceId);
    }
  }, [params.instanceId, params.pageId, params.pageLibraryId, params.containerId, setInstanceId]);

  return params;
};

export default useRoutedParamsWithContext;
